import React from "react";
import PropTypes from "prop-types";
import { InputField } from "../../FormField";
import moment from "moment";

const Part3 = ({ data }) => (
  <table
    style={{
      margin: "10px 0px",
      width: "100%",
      borderCollapse: "collapse",
      border: "1px solid #000",
    }}
  >
    <tbody>
      <tr>
        <td
          style={{
            fontWeight: "bold",
            backgroundColor: "#edb8be",
            paddingLeft: 10,
            borderBottom: "1px solid #000",
          }}
        >
          III)&nbsp;DEPENDANT(S) PARTICULARS - Complete this section only if you are applying for
          Group Hospital and Surgical Insurance for your dependants. If you have more than 3
          children, please furnish the information of all your children after the 3<sup>rd</sup>{" "}
          child on a separate sheet of paper.
        </td>
      </tr>
      <tr>
        <td>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    verticalAlign: "bottom",
                    width: 120,
                  }}
                  rowSpan={2}
                >
                  Relationship
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    verticalAlign: "bottom",
                  }}
                  rowSpan={2}
                >
                  Name (According to NRIC / Passport)
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    verticalAlign: "bottom",
                  }}
                  rowSpan={2}
                >
                  NRIC / <br />
                  Passport No.
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    verticalAlign: "bottom",
                  }}
                  rowSpan={2}
                >
                  Gender
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    width: 180,
                  }}
                  colSpan={3}
                >
                  Date of Birth
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                  rowSpan={2}
                >
                  Height
                  <br />
                  (m)
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                  rowSpan={2}
                >
                  Weight
                  <br />
                  (kg)
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    width: 60,
                  }}
                >
                  DD
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    width: 60,
                  }}
                >
                  MM
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    width: 60,
                  }}
                >
                  YYYY
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  Spouse
                </td>
                <td
                  id="RO_SpouseName"
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  <InputField name={"SpouseName"} {...data["SpouseName"]} />
                </td>
                <td
                  id="RO_SpouseIdentification"
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  <InputField name={"SpouseIdentification"} {...data["SpouseIdentification"]} />
                </td>
                <td
                  id="RO_SpouseGender"
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  <InputField name={"SpouseGender"} {...data["SpouseGender"]} />
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                  id="RO_SpouseBirthDateDay"
                >
                  <InputField
                    name={"SpouseBirthDate"}
                    {...data["SpouseBirthDate"]}
                    format={value => value && moment(value).format("DD")}
                  />
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                  id="RO_SpouseBirthDateMonth"
                >
                  <InputField
                    name={"SpouseBirthDate"}
                    {...data["SpouseBirthDate"]}
                    format={value => value && moment(value).format("MM")}
                  />
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                  id="RO_SpouseBirthDateYear"
                >
                  <InputField
                    name={"SpouseBirthDate"}
                    {...data["SpouseBirthDate"]}
                    format={value => value && moment(value).format("YYYY")}
                  />
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  <InputField
                    name={"SpouseHeight"}
                    {...data["SpouseHeight"]}
                    style={{ width: 50 }}
                  />
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  <InputField
                    name={"SpouseWeight"}
                    {...data["SpouseWeight"]}
                    style={{ width: 50 }}
                  />
                </td>
              </tr>
              {Array.of(
                { serverId: "First", number: 1, postfix: "st" },
                { serverId: "Second", number: 2, postfix: "nd" },
                { serverId: "Third", number: 3, postfix: "rd" }
              ).map(({ serverId, number, postfix }) => (
                <tr key={number}>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    {number}
                    <sup>{postfix}</sup>
                    {" Child"}
                  </td>
                  <td
                    id={`RO_${serverId}ChildName`}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <InputField name={`${serverId}ChildName`} {...data[`${serverId}ChildName`]} />
                  </td>
                  <td
                    id={`RO_${serverId}ChildIdentification`}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <InputField
                      name={`${serverId}ChildIdentification`}
                      {...data[`${serverId}ChildIdentification`]}
                    />
                  </td>
                  <td
                    id={`RO_${serverId}ChildGender`}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <InputField
                      name={`${serverId}ChildGender`}
                      {...data[`${serverId}ChildGender`]}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id={`RO_${serverId}ChildBirthDateDay`}
                  >
                    <InputField
                      name={`${serverId}ChildBirthDate`}
                      {...data[`${serverId}ChildBirthDate`]}
                      format={value => value && moment(value).format("DD")}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id={`RO_${serverId}ChildBirthDateMonth`}
                  >
                    <InputField
                      name={`${serverId}ChildBirthDate`}
                      {...data[`${serverId}ChildBirthDate`]}
                      format={value => value && moment(value).format("MM")}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    id={`RO_${serverId}ChildBirthDateYear`}
                  >
                    <InputField
                      name={`${serverId}ChildBirthDate`}
                      {...data[`${serverId}ChildBirthDate`]}
                      format={value => value && moment(value).format("YYYY")}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <InputField
                      name={`${serverId}ChildHeight`}
                      {...data[`${serverId}ChildHeight`]}
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <InputField
                      name={`${serverId}ChildWeight`}
                      {...data[`${serverId}ChildWeight`]}
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
);

Part3.propTypes = {
  data: PropTypes.shape({}),
};

export default Part3;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Ge/GEHD201808/Part3.js